import { useLocaleState } from "ra-core";

import { useConfigurationContext } from "../root/ConfigurationContext";

/** Formats a whole amount in the configured currency (Settings → Deals). */
export const useFormatAmount = () => {
  const [locale = "en"] = useLocaleState();
  const { currency } = useConfigurationContext();
  return (amount: number | null | undefined) =>
    new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(amount ?? 0);
};
